import { makeAutoObservable, runInAction } from 'mobx';
import type { Country } from '@/models/country/types';
import { fetchCountries } from '@/models/country/service';

class CountryStore {
  countries: Country[] = [];
  private request: Promise<Country[]> | null = null;

  constructor() {
    makeAutoObservable<this, 'request'>(this, { request: false });
  }

  get byName(): Map<string, Country> {
    return new Map(this.countries.map((country) => [country.name, country]));
  }

  get byId(): Map<string, Country> {
    return new Map(this.countries.map((country) => [country.id_country, country]));
  }

  // Страна по префиксу логина (lrb_…, lkz_…) — когда названия страны в данных нет.
  byLogin(login: string | undefined): Country | undefined {
    if (!login) return undefined;
    return this.countries.find(
      (country) => country.prefix_login && login.startsWith(country.prefix_login)
    );
  }

  // Справочник общий для всех экранов с деньгами: грузится один раз за сессию.
  // Без него суммы показываются без знака валюты, поэтому ошибку не пробрасываем,
  // а следующий вызов повторит запрос.
  load(): Promise<Country[]> {
    this.request ??= fetchCountries('0').then(
      (countries) => {
        runInAction(() => {
          this.countries = countries;
        });
        return countries;
      },
      () => {
        this.request = null;
        return [];
      }
    );
    return this.request;
  }
}

export const countryStore = new CountryStore();
